import React from 'react'
import { ErrorMessage } from 'formik'

interface RenderErrorProps {
  name: String
  id: String
}

const RenderError: React.FC<RenderErrorProps> = (props: any) => {
  if (!props.errors[props.name] || (props.errors[props.name] && props.submitCount === 0)) {
    return (
      <span className="error" id={props.id}></span>
    )
  }
  if ((props.inlineValidation || props.submitCount > 0)) {
    return (
      <ErrorMessage name={props.name} render={msg => <span className="error" id={props.id}>{msg}</span>} />
    )
  } else {
    return null
  }
}

export default RenderError